import {
  GroupBase,
  PlaceholderProps,
} from "react-select"
import { clx } from "~/design-system"

const Placeholder = <
  Option,
  IsMulti extends boolean,
  Group extends GroupBase<Option>
>({
  innerProps,
  children,
  className,
  cx,
}: PlaceholderProps<Option, IsMulti, Group>) => (
  <div
    {...innerProps}
    className={clx(
      "txt-base-regular text-ui-fg-muted absolute top-1/2 -translate-y-1/2 select-none",
      className
    )}
  >
    {children}
  </div>
)

export default Placeholder